// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import TerceraBaseWindowTemplate from '@front/templates/TerceraBaseWindowTemplate.html';
import { TerceraWindowBase } from './TerceraWindowBase';
export class UpdateNotificationScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    oncomplete() {
        super.oncomplete();
        this.localize();
    }
    localize() {
        void this.set({
            header: Resources.getResource('screen.updateNotification.header')
        });
    }
}
TerceraWindowBase.extendWith(UpdateNotificationScreen, {
    template: TerceraBaseWindowTemplate,
    data: function () {
        return {
            movable: false,
            showHeader: true,
            showFooter: false,
            resizable: false,
            canSelect: false,
            focused: true,
            showFullscreenCloud: false,
            closeBtnVisible: false,
            width: 300,
            top: 60,
            right: 4,
            laterButtonCallback: null,
            style_addition_body: 'screen-body'
        };
    },
    partials: {
        bodyPartial: '<reactUpdateNotificationScreen on-onLaterButtonClick="laterButtonCallback" isForceUpdate="false" />'
    }
});
